import { Card, Skeleton } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { formatDate } from "../../services/util";
import { useNavigate } from "react-router";
import CustomTable from "../common/Table";
import { SettingContext } from "../../routes";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import CustomHeader from "../common/Header";

const ShiftNotes = () => {
    const { selectedDates, setSingleSelectedHotels, selectedHotels } =
        useContext(SettingContext);
    const staff_id = localStorage.getItem(`x-dashboard-staffid`);
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const navigate = useNavigate();
    const hotel_ids = selectedHotels;
    const [start_date, end_date] = selectedDates;
    const [currentPage, setCurrentPage] = useState(1);

    const [sortedInfo, updateSortedInfo] = useState({
        order: "descend",
        columnKey: "shift_notes_count",
    });
    const [formData, setFormData] = useState({
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        staff_id,
        page: 0,
        limit: 10,
        hotel_ids,
        all_selected: hotel_ids.length > 0 ? false : true,
        hotel_type: "all",
        sort_by: sortedInfo.columnKey,
        sorting: sortedInfo.order === "ascend" ? 2 : 1,
    });

    const {
        status: shiftNotesCountStatus,
        data: shiftNotesCountRes,
        refetch: fetchShiftNotesCount,
    } = useQuery(
        "shiftNotesTable",
        async () => {
            return await HTTP(
                "/dashboard/getDashboardShiftNotesCountsHotelWise",
                { ...formData },
            );
        },
        { enabled: false },
    );

    useEffect(() => {
        fetchShiftNotesCount();
    }, []);

    useEffect(() => {
        fetchShiftNotesCount();
    }, [formData]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    useEffect(() => {
        const hotel_ids = selectedHotels;
        setFormData({
            ...formData,
            hotel_ids,
            page: 0,
            all_selected: hotel_ids.length === 0 ? true : false,
        });
    }, [selectedHotels]);

    useEffect(() => {
        if (shiftNotesCountStatus === "success") {
            const { data: transactionData, total } = shiftNotesCountRes;
            setTotalRecords(total);
            setTableData(transactionData);
        }
    }, [shiftNotesCountStatus, shiftNotesCountRes]);

    function getHotelWiseShiftNotes(e) {
        const hotel_id = e.currentTarget.getAttribute("id");
        const hotel_name = e.currentTarget.getAttribute("data-hotelname");
        setSingleSelectedHotels(`${hotel_name}#${hotel_id}`);
        return navigate(`/shift_notes/${hotel_id}`);
    }

    const columns = [
        {
            title: "Hotel",
            dataIndex: "hotel_name",
            key: "hotel_name",
            sorter: () => {},
            render: (text, record) => (
                <span
                    onClick={getHotelWiseShiftNotes}
                    id={record.hotel_id}
                    data-hotelname={text}
                    style={{ color: "#1890ff", cursor: "pointer" }}
                >
                    {text}
                </span>
            ),
            sortOrder:
                sortedInfo.columnKey === "hotel_name" ? sortedInfo.order : null,
        },
        {
            title: "Shift Notes",
            dataIndex: "shift_notes_count",
            key: "shift_notes_count",
            render: (text, record) => (
                <span id={record.transaction_id}>{text}</span>
            ),
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "shift_notes_count"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "Note Resolution Rate",
            dataIndex: "notes_resolution_rate",
            key: "notes_resolution_rate",
            render: (text, record) => (
                <span id={record.transaction_id}>{text}%</span>
            ),
        },
    ];

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, columnKey } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 2 : 1;
            others.sort_by = columnKey;
            updateSortedInfo({ columnKey, order });
        } else {
            delete formData.sorting;
            delete formData.sort_by;
            updateSortedInfo({});
        }

        const newFormData = {
            ...formData,
            ...others,
        };
        setFormData(newFormData);
        setCurrentPage(current);
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader />
            <Card className="box-shadow margin-10">
                {shiftNotesCountStatus === "loading" ||
                shiftNotesCountStatus === "idle" ? (
                    <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 20, width: 40 }}
                    />
                ) : (
                    <CustomTable
                        columns={columns}
                        tableData={tableData}
                        noOfrecords={totalRecords}
                        currentPage={currentPage}
                        handleTableChange={handleTableChange}
                        rowKey="shift_notes_id"
                        className="review-table"
                    />
                )}
            </Card>
        </Card>
    );
};

export default ShiftNotes;
